import { searchRoles } from '@infuse/api/iam/role';
import { useGenericRoles } from './generic/useGenericRoles';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { searchTenantRoles } from '@infuse/api/iam/tenant';
import { searchOrganisationRoles } from '@infuse/api/iam/organisation';

export const useRoles = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericRoles({
      apiFn: searchTenantRoles,
      queryKeys: ['roles', 'tenant'],
      initialParentId: user?.tenantId
    });
  } else if (level === UserLevel.ORGANISATION) {
    return useGenericRoles({
      apiFn: searchOrganisationRoles,
      queryKeys: ['roles', 'organisation'],
      initialParentId: user?.organisationId
    });
  }

  return useGenericRoles({
    apiFn: searchRoles,
    queryKeys: ['roles']
  });
};
